import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import RadioGroupDemo from './radio-group-demo';
import RadioNogroupDemo from './radio-nogroup-demo';

import Arranger from '~c/components/base/arranger';

interface Props {
  className?: string;
}

const RadioDemo: React.FC<Props> = ({ className }) => {
  return (
    <Arranger className={className} alignItems="flex-start">
      <RadioGroupDemo />
      <RadioNogroupDemo />
    </Arranger>
  );
};

export default muiStyled(RadioDemo)(({ theme }) => css``);
